<template>
  <div>
    <NuxtLoadingIndicator />
    <NuxtRouteAnnouncer />
    <!-- <Toast /> -->
    <NuxtLayout>
      <NuxtPage />
      <WrChatBotButton />
      <WrCookieConfirmation />
    </NuxtLayout>
  </div>
</template>
